import React from 'react';
import ProductItemView from '../ProductItemViewMobile';
import news from '../../resource/lis_mobile/news.png';

const NewsMobile = () => {
    return (
        <ProductItemView
            title="Novedades"
            items={["Tablero de control gerencial en tiempo real",
                "Módulo de caja con soporte para pago con billeteras electrónicas QR",
                "Mecanismo de notificaciones, alertas y comunicaciones internas integrado",
                "Envío de resultados por correo y whatsapp"]}
            image={news} />
    );
};

export default NewsMobile;